import * as types from './mutation-types'

export const loadRooms = ({ commit }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/appointment/room').then((response) => {
            commit(types.LOAD_ROOMS, response.data)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateRoom = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('update/appointment/room/'+ data.id, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const createRoom = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/appointment/room', data).then((response) => {
            commit(types.ADD_ROOM, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}



export const deleteRoom = ({ commit }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete('delete/appointment/room/' + id).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

